module.exports = "/_next/static/media/fb7a5981b9de7875b125ef193da0d8d7.svg";